import React from 'react';

import {
  privatePensionFiltersQuery,
  privatePensionAssetsQuery,
} from '../../../../../store/customerAssetDetail/selector';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { DynamicProductTable } from '../_dynamic';

import { tableHead } from './constants';
import ProductItem from './item';

export const PrivatePensionTable: React.FC<DynamicAssetTableProps> = (props) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={privatePensionAssetsQuery}
      filtersQuery={privatePensionFiltersQuery}
      tableHeadItems={tableHead}
      tabletColumns={5}
      tabletRows={2}
      mobileColumns={3}
      mobileRows={3}
      mobileFields={[
        { key: 'productNameNormalized', label: 'Previdência' },
        { key: 'positionDateNormalized', label: 'Data posição' },
        { key: 'planNormalized', label: 'Plano' },
        { key: 'investmentTaxNormalized', label: 'Tributação' },
        { key: 'dayNormalized', label: 'Dia' },
        { key: 'monthNormalized', label: 'Mês' },
        { key: 'yearNormalized', label: 'Ano' },
        { key: 'valueNormalized', label: 'Valor' },
      ]}
    />
  );
};
